// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Sibling imports
const TopCallToActionExplainer = require('./explainer')
const TopCallToActionJumpToGrid = require('./jump-to-grid')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionSplitLeading')

function TopCallToActionSplitLeading(props) {
  return tag('div', {
    ref: props.forwardedRef,
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag(TopCallToActionExplainer),
    tag(TopCallToActionJumpToGrid, {
      href: '#discover'
    })
  )
}

module.exports = TopCallToActionSplitLeading
